import React, { useEffect, useState } from "react"
import { Navigate, useNavigate } from "react-router-dom"
import axios from "axios"
import { useAuth0 } from "@auth0/auth0-react"
import { Button, Card } from "antd"
import { ConsoleSqlOutlined, PlusOutlined } from "@ant-design/icons"
import Header from "../components/Header"
import Footer from "../components/Footer"
import { apiBaseUrl } from "../config.js"

const Home = () => {
  const navigate = useNavigate()
  const { user, logout, getIdTokenClaims, getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0()
  const [userData, setUserData] = useState(null)
  const [entries, setEntries] = useState([])

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      if (!userData) {
        setUser()
        if (entries.length === 0) {
          getEntries()
        }
      }
    }
  }, [ ])

  const setUser = async () => {
    try {
      if (isAuthenticated && user) {
        const token = await getAccessTokenSilently()
        const userResp = await axios.get(`${apiBaseUrl}/api/user`, {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        })
        setUserData(userResp.data)
      }
    } catch (error) {
      console.error('Error fetching user entries:', error)
    }
  }

  const getEntries = async () => {
    try {
      if (isAuthenticated && user) {
        const token = await getAccessTokenSilently()
        const entries = await axios.get(`${apiBaseUrl}/api/entries`, {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        })
        setUserData(entries.data)
      }
    } catch (error) {
      console.error('Error fetching user entries:', error)
    }
  }

  return (
    <div className="flex flex-col h-screen">
      <Header />
      <div className="grow p-8 flex items-start">
        <Card
          className="shadow-md rounded-lg max-w-xs max-h-xs cursor-pointer"
          onClick={() => navigate("/new-entry")}
        >
          <div className="flex flex-col items-center justify-center p-6">
            <Button
              type="primary"
              shape="circle"
              icon={<PlusOutlined />}
              size="large"
              className="bg-blue-500 text-white flex items-center justify-center"
            />
            <p className="mt-4 text-lg font-semibold text-gray-700">Add New Entry</p>
          </div>
        </Card>
      </div>
      <Footer />
    </div>
  )
}

export default Home